import React, { memo } from 'react';
import { useWindowSize } from '@surveycake/rhooks';
import { addOptionPrefix } from 'app/modules/subject';
import {
  Grid,
  SingleOption,
  ElseTextField
} from 'app/pages/Survey/Subject/elements';
import { useChoiceOneAnswer } from '../hooks';

function RadioType() {
  const {
    columnDesktop,
    columnMobile,
    optionStates,
    value: valuesFromAnswer,
    options,
    onChange,
    elseValue,
    onElseChange,
    onElseFinished
  } = useChoiceOneAnswer();
  const { width } = useWindowSize();
  const desktop = width >= 720;
  const column = desktop ? columnDesktop : columnMobile;

  if (!options || !optionStates) {
    return null;
  }

  return (
    <Grid column={column} gutter={10}>
      {options.map(({ ID, text, imgs, youtubeid, elses }) => {
        const { visible, enable, excluded } = optionStates[ID];

        if (!visible) {
          return null;
        }

        const value = addOptionPrefix(ID);
        const checked = value === valuesFromAnswer;
        const disabled = !enable;

        return (
          <SingleOption
            key={value}
            Id={ID}
            size="small"
            rippleAnimationDuration={700}
            value={value}
            label={text}
            onChange={onChange}
            checked={checked}
            excluded={excluded}
            disabled={disabled}
            imageLink={imgs || undefined}
            youtubeID={youtubeid || undefined}
          >
            {elses === 1 && checked && (
              <ElseTextField
                initialValue={elseValue}
                onChange={onElseChange}
                onFinished={onElseFinished}
              />
            )}
          </SingleOption>
        );
      })}
    </Grid>
  );
}

export default memo(RadioType);
